import { render } from "./CampaignDetail.vue?vue&type=template&id=36ba6a4f&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"

import "./CampaignDetail.vue?vue&type=style&index=0&id=36ba6a4f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ba6a4f"]])

export default __exports__